// extracted by mini-css-extract-plugin
export default {"icon":"Modal_icon__23dei","content":"Modal_content__Irf0Y","confirm":"Modal_confirm__AHcR3","container":"Modal_container__VACfS"};